import { useEffect, useState } from "react";
import { Download } from "lucide-react";

export default function InstallPrompt() {
  const [deferred, setDeferred] = useState(null);
  const [installed, setInstalled] = useState(false);

  useEffect(() => {
    const onPrompt = (e) => { e.preventDefault(); setDeferred(e); };
    const onInstalled = () => { setInstalled(true); setDeferred(null); };
    window.addEventListener("beforeinstallprompt", onPrompt);
    window.addEventListener("appinstalled", onInstalled);
    return () => {
      window.removeEventListener("beforeinstallprompt", onPrompt);
      window.removeEventListener("appinstalled", onInstalled);
    };
  }, []);

  if (!deferred || installed) return null;

  return (
    <button
      onClick={async () => { deferred.prompt(); await deferred.userChoice; setDeferred(null); }}
      data-testid="pwa-install-btn"
      className="fixed bottom-5 right-5 z-[90] flex items-center gap-2 rounded-full bg-saffron px-5 py-3 text-sm font-bold text-white shadow-2xl shadow-saffron/40 transition-transform hover:scale-105"
    >
      <Download className="h-4 w-4" /> Install INDIAFAST App
    </button>
  );
}
